import React from 'react'
import Page from '../components/Page'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from 'axios'
import StorageService from '../services/StorageService'
import { MdCameraAlt, MdFace, MdDone, MdClear, MdCreate } from 'react-icons/md'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import PosUserForm from '../components/PosUserForm'
import { getProfile, getProfile_v2 } from '../utils/dropdownlist'
import { BsPlusSquareFill } from 'react-icons/bs'
import { IconContext } from 'react-icons/lib'

class PosUserGroup extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      modal: false,
      userModal: false,
      confirmModal: false,
      selectedData: '',
      selectedId: '',
      user_id: '',
      email: '',
      name: '',
      contact: '',
      role: '',
      profileId: '',
      isGlobal: true,
      isEdit: false,
      userId: '',
      userList: [],
      roleList: [],
      storeList: [],
      redirect: false,
      duplicateId: false,
      user_role: '',
      tabList: ['Product', 'Category', 'Import'],
      activeTab: '1',
      user_group: '',
    }
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      })
    }
  }

  products = id => () => {
    this.props.history.push({
      pathname: '/posuser/posusergroup/products/' + id,
    })
  }

  toggle = (action, id) => () => {
    let obj = {}

    if (id !== undefined || id !== null) {
      obj = this.state.userList.find(e => e.id === id)
    }

    return this.setState({
      modal: !this.state.modal,
      isEdit: id != undefined || (id != null && action == 'EDIT') ? true : false,
      userId: id != undefined || (id != null && action == 'EDIT') ? id : '',
      email: id != undefined || (id != null && action == 'EDIT') ? obj.email : '',
      name: id != undefined || (id != null && action == 'EDIT') ? obj.name : '',
      contact: id != undefined || (id != null && action == 'EDIT') ? obj.contact : '',
    })
  }

  toggleUser =
    (item = null) =>
    () => {
      return this.setState({
        userModal: !this.state.userModal,
        userId: item != null ? item.id : '',
        user_group: item != null ? item.user_group : '',
        isEdit: item != null ? true : false,
      })
    }

  toggleConfirmModal = (name, id) => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
      selectedData: name,
      selectedId: id,
    })
  }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    })

    this.setState({
      modal: false,
      userModal: false,
      confirmModal: false,
    })

    if (reload) {
      window.location.reload()
    } else {
      this.getUserList()
    }
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  IDHandler = event => {
    const { name, value } = event.target

    let duplicateId = this.state.userList.some(x => x.user_id === value)

    this.setState({
      [name]: value,
      duplicateId: duplicateId,
    })
  }

  handleSubmit = event => {
    event.preventDefault()
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const comp = StorageService.getSession('selected_org')
    if (!this.state.isEdit) {
      const data = {
        session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
        user_group: this.state.user_group,
        company_id: comp.CompanyID,
        created_by: user.email,
      }

      axios
        .post(url + ':3000/v1/user/group/create', data)
        .then(response => {
          const result = response.data
          if (result.error == true) {
            this.notificationSystem.addNotification({
              title: <MdClear />,
              message: result.message,
              level: 'error',
              position: 'br',
              autoDismiss: 4,
              dismissible: 'click',
            })
            return
          }

          this.notificationSystem.addNotification({
            title: <MdDone />,
            message: 'New user group added successfully.',
            level: 'success',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          this.setState({ modal: false, user_group: '' })
          this.getUserList()
        })
        .catch(error => {
          if (error.response) {
            alert(error.response.data.message)
          }
          // else if (error.request) {
          //   console.log(error.request);
          // }
          else {
            alert('Error', error.message)
          }
        })
    } else {
      const data = {
        session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
        id: this.state.userId,
        user_group: this.state.user_group,
        company_id: comp.CompanyID,
        update_by: user.email,
      }

      axios
        .post(url + ':3000/v1/user/group/update', data)
        .then(response => {
          const result = response.data
          if (result.error == true) {
            this.notificationSystem.addNotification({
              title: <MdClear />,
              message: result.message,
              level: 'error',
              position: 'br',
              autoDismiss: 4,
              dismissible: 'click',
            })
            return
          }

          this.notificationSystem.addNotification({
            title: <MdDone />,
            message: 'User group updated successfully.',
            level: 'success',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          this.setState({ userModal: false, user_group: '' })
          this.getUserList()
        })
        .catch(error => {
          alert(error)
        })
    }
  }

  delete = id => {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      id: this.state.selectedId,
      delete_by: user.email,
    }

    axios
      .post(url + ':3000/v1/user/group/delete', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'User Group deleted successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ confirmModal: false })
        this.getUserList()
      })
      .catch(error => {
        alert(error)
      })
  }

  getUserList = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3000/v1/user/group', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.setState({ userList: result.data })
      })
      .catch(error => {
        alert(error)
      })
  }

  componentDidMount() {
    //getProfile.call(this);
    this.getProfile()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    this.setState({
      user_role: comp.Role,
    })
    //if (user.superUser) {
    if (comp.Role === 'Superuser' || comp.Role === 'Admin') {
      this.getUserList()
    }
    // } else {
    //   this.setState({
    //     redirect: true,
    //   });
    // }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  getProfile() {
    getProfile_v2()
      .then(result => {
        if (this._isMounted) {
          if (result.error == true && result.message != 'Success') {
            alert(result.message)
            return
          }
          this.setState({
            roleList: result.data.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  detail = id => {
    this.props.history.push({
      pathname: '/posuser/posusergroup/' + id,
    })
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }

    return (
      <>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        <div className="text-right mb-4">
          <div className="ps-btn-group">
            <Button color="link" onClick={this.toggle('ADD', null)}>
              <IconContext.Provider value={{ color: '#2a2c6b' }}>
                <BsPlusSquareFill size={25} />
              </IconContext.Provider>
            </Button>
          </div>
        </div>
        <Table responsive hover className="ps-table tb-col-5">
          <thead>
            <tr>
              <th>User Group</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {this.state.userList.length < 1 && (
              <tr>
                <td colSpan="5">
                  <div className="ps-empty-data">
                    <div className="empty-content">
                      <MdCreate />
                      <h4>No data to show</h4>
                      <span>Click the 'Create' button to add new user group</span>
                    </div>
                  </div>
                </td>
              </tr>
            )}

            {this.state.userList &&
              this.state.userList.length > 0 &&
              this.state.userList.map((item, index) => {
                return (
                  <tr key={item.id}>
                    <td>{item.user_group}</td>
                    <td>
                      <div className="ps-action-button">
                        <Button className="theme-button theme-button-secondary" onClick={this.products(item.id)}>
                          Products
                        </Button>
                        <Button className="theme-button theme-button-secondary" onClick={() => this.detail(item.id)}>
                          View
                        </Button>
                        <Button className="theme-button theme-button-primary-light" onClick={this.toggleUser(item)}>
                          Edit
                        </Button>
                        <Button color="link" className="theme-button theme-button-primary" onClick={this.toggleConfirmModal(item.user_group, item.id)}>
                          Delete
                        </Button>
                      </div>
                    </td>
                  </tr>
                )
              })}
          </tbody>
        </Table>

        <Modal isOpen={this.state.modal} toggle={this.toggle()} className={this.props.className} centered>
          <Form onSubmit={this.handleSubmit} className="AuthForm">
            <ModalHeader toggle={this.toggle()}>User Group Information</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label for="user_group">User Group</Label>
                    <Input type="text" name="user_group" value={this.state.user_group} onChange={this.changeHandler} required />
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-secondary" onClick={this.toggle()}>
                Close
              </Button>
              <Button className="theme-button theme-button-primary" type="submit">
                {this.state.isEdit ? 'Save' : 'Add'}
              </Button>{' '}
            </ModalFooter>
          </Form>
        </Modal>

        <Modal isOpen={this.state.userModal} toggle={this.toggleUser()} className={this.props.className} centered>
          <Form onSubmit={this.handleSubmit} className="AuthForm">
            <ModalHeader toggle={this.toggleUser()}>User Group Information</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label for="user_group">User Group</Label>
                    <Input type="text" name="user_group" value={this.state.user_group} onChange={this.changeHandler} required />
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-secondary" onClick={this.toggleUser()}>
                Close
              </Button>
              <Button className="theme-button theme-button-primary" type="submit">
                {this.state.isEdit ? 'Save' : 'Add'}
              </Button>{' '}
            </ModalFooter>
          </Form>
        </Modal>

        <Modal isOpen={this.state.confirmModal} toggle={this.toggleConfirmModal()} className={this.props.className} closeModal={this.closeModal} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleConfirmModal()}>Delete User</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>Are you sure you want to delete {this.state.selectedData} ?</p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.toggleConfirmModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.delete()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>
      </>
    )
  }
}
export default PosUserGroup
